/** Primitivos de cor (hex #RRGGBB). Fonte: design system ARIDE. */
export const purpleBrand = {
  100: '#F4EBFF',
  200: '#E2C7FF',
  300: '#CFA3FF',
  400: '#BC7FFF',
  500: '#A95BFF',
  600: '#9537FC',
  700: '#7F27DF',
  800: '#6919C2',
  900: '#560EA5',
  1000: '#430587',
  1100: '#33006A',
  1200: '#25004D'
} as const;

export const yellowBrand = {
  100: '#FFFAE5',
  200: '#FFF2BF',
  300: '#FFEB99',
  400: '#FFE473',
  500: '#FFDC4D',
  600: '#FFD527',
  700: '#F3C401',
  800: '#D1A800',
  900: '#AF8D00',
  1000: '#8D7200',
  1100: '#6B5600',
  1200: '#493B00'
} as const;

export const blueBrand = {
  100: '#EAF4FF',
  200: '#C6DFFF',
  300: '#A2CBFF',
  400: '#7DB7FF',
  500: '#59A3FF',
  600: '#3187F0',
  700: '#1E70D3',
  800: '#0F5AB6',
  900: '#034699',
  1000: '#00387C',
  1100: '#002B5F',
  1200: '#001D41'
} as const;

export const blue = {
  100: '#ECF2FF',
  200: '#C9DCFF',
  300: '#A7C6FF',
  400: '#84AFFF',
  500: '#6299FF',
  600: '#4083FF',
  700: '#2D6DE5',
  800: '#1C58C8',
  900: '#0E45AB',
  1000: '#04348E',
  1100: '#002771',
  1200: '#001D54'
} as const;

export const green = {
  100: '#F5FFF8',
  200: '#D9FFE4',
  300: '#BCFFCF',
  400: '#9BF8B6',
  500: '#87E1A2',
  600: '#75CA8E',
  700: '#64B47B',
  800: '#549D69',
  900: '#448658',
  1000: '#367047',
  1100: '#295937',
  1200: '#1D4228'
} as const;

export const orange = {
  100: '#FFF3E6',
  200: '#FFE3C1',
  300: '#FFD29D',
  400: '#FFC178',
  500: '#FFB053',
  600: '#FF9F2E',
  700: '#F68909',
  800: '#D47300',
  900: '#B26000',
  1000: '#904E00',
  1100: '#6E3B00',
  1200: '#4C2900'
} as const;

export const red = {
  100: '#FFEEED',
  200: '#FFD1CE',
  300: '#FFB4AE',
  400: '#FF968F',
  500: '#FF796F',
  600: '#FF5C50',
  700: '#E2483D',
  800: '#C5372C',
  900: '#A8281E',
  1000: '#8B1B13',
  1100: '#6D110A',
  1200: '#500904'
} as const;

export const neutral = {
  0: '#FFFFFF',
  100: '#F8F8F8',
  200: '#F0F1F2',
  300: '#DDDEE1',
  400: '#B7B9BE',
  500: '#8C8F97',
  600: '#6B6E76',
  700: '#505258',
  800: '#3B3D42',
  900: '#292A2E',
  1000: '#1E1F21',
  1100: '#121212',
  1200: '#000000'
} as const;
